export const isSomeExpired = (cart) => {
  const tickets = [...cart.cartTickets, ...cart.cartCollaboratorTickets, ...cart.cartPacketTickets, ...cart.cartCollaboratorPacketTickets]
  
  const expired = tickets.some(ticket => {
    if (ticket.expire_at !== null) {
      if (new Date(ticket.expire_at) < new Date()) { // Ha expirado
        return true
      } else {
        const treintaMins = new Date(ticket.created_at)
        treintaMins.setSeconds(treintaMins.getSeconds() + 30 * 60)
        if (treintaMins < new Date()) { // ha expirado
          return true
        }
      }
      return false
    }
  })
  
  return expired
}